import React, { ReactElement } from 'react'
// @ts-expect-error
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox.css'

import Pad from '../../comps/Pad'
import PageReport from '../../comps/PageReport'

import styles from './ImageReport.module.css'

export interface ImageReportProps {
  company: string
  image: string
  title: string
}

export default React.memo<ImageReportProps>(function ImageReport({
  company,
  image,
  title,
}) {
  const picture = React.useMemo((): ReactElement => {
    return (
      <div className={styles['container']}>
        {' '}
        <Pad amt={20} />
        <div className={styles['frame']}>
          <img
            alt="Customer Images"
            className={styles['image']}
            data-fancybox
            data-src={image}
            src={image}
          />
        </div>
      </div>
    )
  }, [image])

  React.useEffect(() => {
    Fancybox.bind('[data-fancybox]', {
      Thumbs: {
        autoStart: false,
      },
    })
  }, [])

  return (
    <PageReport company={company} companyBorder={true} title={title}>
      {picture}
    </PageReport>
  )
})
